import { isEmpty, isNumber, isUndefined, omitBy } from 'lodash-es'

type YmUserParams = {
  UserID?: string | number
  ReferralDoctorID?: string | number
}

// NOTE: https://yandex.ru/support/metrica/data/visit-params_data.html
export const ymGoal = (target: string, params?: unknown) => {
  if (window.ym && isNumber(window.__YM_COUNTER_ID__)) {
    window.ym(window.__YM_COUNTER_ID__, 'reachGoal', target, params)
  }
}

export const ymUserParams = (payload: YmUserParams) => {
  const nonNullablePayload = omitBy(payload, isUndefined)

  if (window.ym && !isEmpty(nonNullablePayload) && isNumber(window.__YM_COUNTER_ID__)) {
    window.ym(window.__YM_COUNTER_ID__, 'userParams', nonNullablePayload)
  }
}
